'use strict';

var BaseModule = require('modules/base/module');
var ShareModule = require('modules/share/module');
var TrackingModule = require('modules/tracking/module');

module.exports = function (App) {
    App.module('TrackingModule', TrackingModule);
    App.module('BaseModule', BaseModule);
    App.module('ShareModule', ShareModule);
};